// src/config/product.js
// The public product name and URLs -- one place for the frontend.
// (Backend: PRODUCT_NAME / PUBLIC_BASE_URL settings; public/index.html uses %REACT_APP_PRODUCT_NAME%.)

export const PRODUCT_NAME =
  process.env.REACT_APP_PRODUCT_NAME || "T4R Learning Journey Design Agent";
export const PRODUCT_TAGLINE = "An AI-supported tool for structured curriculum co-design";
export const PUBLIC_BASE_URL =
  process.env.REACT_APP_PUBLIC_BASE_URL || "https://learning-journey.k8.design";
export const MCP_URL = `${PUBLIC_BASE_URL}/mcp`;
export const PUBLISHER = "K8 Institut für strategische Ästhetik gGmbH";
export const PROJECT = "Twin4Resilience (Interreg North-West Europe)";
